export const INPUT_PROMPT_BUTTON_ID = "send-message-button"
export const CHAT_PROMPT_FORM_ID = "chat-prompt-form"